import { apiService } from '../../../shared/services/apiService';
import { getFilteredTruthyFieldsObj } from '../../../shared/utils/sortingAndGroupingUtil';
import {
  GetScanDateByInbodyIdResponse,
  ManualScanData,
} from '../../interfaces/customerInbodyData';
import { InbodyType } from '../../../shared/constants/inbody-info/InbodyType';
import { MealPlanOnScanDayInfo } from '../../interfaces/mealPlanOnScanDayInfo';
import { ScanMetadata } from '../../interfaces/scanMetadata';
import { KeyBodyMetricsInfo } from '../../interfaces/keyBodyMetricsInfo';
import {
  ScanService,
  GetInbodyIndicatorsResponse,
  CustomerInbodyTypeOption,
  UpdateScansFromInbodyResponse,
} from './types';

export const nutritionScanService: ScanService = {
  async getScanDateByInbodyId(inbodyId: number | string, ignoreErrorCodes?: number[]) {
    const resp = await apiService.get<GetScanDateByInbodyIdResponse>(
      `api/coach/inbody/${inbodyId}`,
      { ignoreErrorCodes },
    );

    return resp.data;
  },

  async createScanManually(customerId: number, scanDate: ManualScanData) {
    const filteredScanDate = getFilteredTruthyFieldsObj(scanDate);

    const resp = await apiService.post(
      `api/coach/inbody/manual/${customerId}`,
      filteredScanDate,
    );

    return resp.data;
  },

  // connect scan from inbody to customer by inbody id, get new scan from inbody
  async updateScansFromInbody(customerId: number) {
    const resp = await apiService.put<UpdateScansFromInbodyResponse>(
      `/api/coach/inbody/update/${customerId}`,
    );

    return resp.data;
  },

  async getInbodyIndicators(customerId: number, userInbodyType: InbodyType | 'ALL') {
    const resp = await apiService.post<GetInbodyIndicatorsResponse>(
      `/api/users/${customerId}/inbody-data`,
      { userInbodyType },
    );

    return resp.data;
  },

  async getCustomerInbodyTypeOptions(customerId: number) {
    const resp = await apiService.get<CustomerInbodyTypeOption[]>(
      `api/users/${customerId}/inbody-types`,
    );

    return resp.data;
  },

  async getScanDates(customerId: number) {
    const resp = await apiService.get<ScanMetadata[]>(
      `api/users/${customerId}/scan-dates`,
    );

    return resp.data;
  },

  async getMealPlansOnScanDay(customerId: number) {
    const resp = await apiService.get<MealPlanOnScanDayInfo[]>(
      `api/coach/inbodydata/${customerId}/mealplan`,
    );

    return resp.data;
  },

  async getKeyBodyMetrics(customerId: number) {
    const resp = await apiService.get<KeyBodyMetricsInfo>(
      `api/coach/user/${customerId}/stats/body-metrics`,
    );

    return resp.data;
  },
};
